import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";

// routers
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

// components
import OrdersPage from "../components/orders/ordersPage/OrdersPage";
import LoginPage from "../components/loginPage/LoginPage";
import Dashboard from "../components/dashboard/Dashboard";
import Header from "../components/header/Header";
import MenuPage from "../components/menuPage/MenuPage";
import ProvisionSetupPage from "../components/provisioning & store setup/provisionSetupPage/ProvisionSetupPage";
import Sales from "../components/sales/Sales";
import Checkout from "../components/sales/components/checkout/Checkout";
import { useSelector, useDispatch } from "react-redux";
import { getMenuList } from "../redux/actions/menu/menuActions";
import { IBaseModel } from "../interfaces/base";
import { API_INTEGRATION_ID } from "../config";
import Reports from "../components/reports/Reports";
import PartnerConfiguration from "../components/PartnerConfiguration/PartnerConfiguration";
import StoreDetails from "../components/PartnerConfiguration/components/storeDetails/StoreDetails";

const AppRouter = (): JSX.Element => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: any) => state.authentication);
  //console.log("user");
  //console.log(user);
  const { isAllMenuLoading, menuItems, isMenuLoaded, error } = useSelector(
    (state: any) => state.getAllMenuReducer
  );
  //console.log(menuItems);
  //console.log(isAllMenuLoading);
  // console.log(isMenuLoaded);
  //console.log(error);

  const fetchMenu = async () => {
    console.log("menu fetching");
    const data: IBaseModel = {
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };
    dispatch(getMenuList(data));
  };

  useEffect(() => {
    if (user !== undefined) {
      fetchMenu();
    }
  }, [dispatch, user]);

  return (
    <Router basename="/BLXOrderHub">
      <Header />
      <Switch>
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/orders" component={OrdersPage} />
        <PrivateRoute exact path="/menus" component={MenuPage} />
        <PrivateRoute exact path="/provision" component={ProvisionSetupPage} />
        <PrivateRoute exact path="/sales" component={Sales} />
        <PrivateRoute exact path="/sales/checkout" component={Checkout} />
        <PrivateRoute exact path="/reports" component={Reports} />
        <PrivateRoute
          exact
          path="/configuration"
          component={PartnerConfiguration}
        />

        <PrivateRoute
          exact
          path="/configuration/details"
          component={StoreDetails}
        />
        <PublicRoute exact path="/login" component={LoginPage} />
        <Redirect to="/login" />
      </Switch>
    </Router>
  );
};

export default AppRouter;
